import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';
import {openViewIntent} from '#core/utils/intent-utils.js';
import {mergeTo} from '#core/utils/config-utils.js';
import {isCrawlerBot} from '#core/utils/url-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';
import {Intents} from '#core/application/intents/index.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Interface} from '../interface.js';

import {applicationHeaderFactory} from './application-header.factory.js';

import SCHEMA from './application-header.schema.yaml';
import PALETTE_SCHEMA from './application-header.palette-schema.yaml';

class ApplicationHeaderFeature extends AbstractVisualFeature {
    get name() {
        return 'ApplicationHeader';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    get hostHeaderHeight() {
        return this.config.hostHeaderHeight;
    }

    get mobileHostHeaderHeight() {
        return this.config.mobileHostHeaderHeight;
    }

    getSerializableVisualConfig(PALETTE) {
        const {cookieConsent, ...config} = this.config;
        const {crossSellMenuLinks} = ApplicationConfig.config;

        return mergeTo(applicationHeaderFactory(PALETTE), {
            CookieConsent: {
                policyLinkIntent: Intents.COOKIE_CONSENT || openViewIntent('cookies-policy'),
            },
            ApplicationMenu: {
                showAuth: BUILT_IN_AUTHORIZATION_UI,
            },
            UserAuthenticationInfo: {
                signupButton: {
                    intent: Intents.REGISTER,
                },
            },
            ApplicationHeader: {
                layout: config.layout,
                cookieConsentView: {
                    hide: isCrawlerBot() || !cookieConsent.show,
                },
                [`${config.layout}Layout`]: {
                    applicationMenu: {
                        // cross-sell menu
                        showCrossSellMenu: !!(crossSellMenuLinks && crossSellMenuLinks.length > 0),
                        _mobile_showCrossSellMenu: false,
                        // search button
                        showSearch: config.showSearchButton,
                        _mobile_showSearch: config.showSearchButton,
                    },
                    mainNavigationBar: {
                        /* Important: settings menu is configured in core/application/modules/settings-menu */
                        buttonPosition: config.settingsAndHelpButtonsPosition,
                        // helpButton
                        showHelpButton: !!Intents.HELP,
                        helpIntent: Intents.HELP,
                        // session time
                        showSessionTime: config.sessionTime.show,
                        sessionTime: {
                            layoutDirection: config.sessionTime.layout,
                            showLabel: config.sessionTime.showLabel,
                        },
                        // current time
                        isCurrentTimeVisible: config.currentTime.show,
                        currentTime: {
                            isOffsetHidden: !config.currentTime.showOffset,
                        },
                    },
                },
            },
            MainNavigationBarClassic: {
                items: buildIntentsFromConfig(ApplicationConfig.config.desktopNavigationBarItems),
            },
        });
    }
}

export const ApplicationHeader = new ApplicationHeaderFeature(Interface);
